import React from 'react';
import './ScenarioComparison.scss';
import { ScenarioProvider } from './context/ScenarioComparisonProvider';
import ScenarioComparisonManager from './ScenarioComparisonManager';

// eslint-disable-next-line arrow-body-style
const ScenarioComparison = () => {
    return (
        <ScenarioProvider>
            <ScenarioComparisonManager />
        </ScenarioProvider>
    );
};

export default ScenarioComparison;
